"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuSearchField = MenuSearchField;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const textfield_1 = require("@react-aria/textfield");
const react_1 = require("react");
const components_1 = require("../../components");
const utils_1 = require("../../utils");
const TextFieldBase_1 = require("../TextFieldBase");
function MenuSearchField(props) {
    const tid = (0, utils_1.useTestIds)(props);
    const inputRef = (0, react_1.useRef)(null);
    const { labelProps, inputProps } = (0, textfield_1.useTextField)({ ...props }, inputRef);
    return ((0, jsx_runtime_1.jsx)(TextFieldBase_1.TextFieldBase, { label: "", labelProps: labelProps, inputProps: inputProps, startAdornment: (0, jsx_runtime_1.jsx)(components_1.Icon, { icon: "search" }), ...tid.search }));
}
